import React, { PureComponent } from 'react';
import style from './index.css';
import { cookie, jsonp } from '@ifeng/three_terminal/es/base/base/index';

class Locationhref extends PureComponent {
    constructor() {
        super();

        this.state = {
            city: '北京',
            cityname: '北京',
            auto_iploc: '110000',
            city_py: 'beijing',
        };
    }

    async componentDidMount() {
        const cityName = this.getCity();

        const getData = this.getAutodata(cityName);

        getData.then(v => {
            if (v.status !== 0) {
                const { match_name, match_citycode, match_pinyin } = v.data[0].match[0];

                this.setState({
                    cityname: match_name,
                    auto_iploc: match_citycode,
                    city_py: match_pinyin,
                });
            }
        });
    }
    getCity = () => {
        const name = 'auto_iploc';
        let auto_iploc = cookie.get(name);

        if (auto_iploc == null || auto_iploc === '') {
            auto_iploc = '110000';
        }

        const winurl = window.location.href;

        if (/city=\d+/gi.test(winurl)) {
            auto_iploc = /city=(\d+)/gi.exec(winurl)[1];
        }

        return auto_iploc;
    };
    getAutodata = async name => {
        const url = '//api.auto.ifeng.com/cms/api/cityInfo_new';

        const parm = {
            match: 1,
            citycode: name,
        };
        let data = await jsonp(url, {
            data: parm,
        });

        return data;
    };
    render() {
        const url = '//iauto.ifeng.com/?c=index&a=city&backUrl=//iauto.ifeng.com';

        return (
            <a href={url} className={style.loc_position}>
                <span />
                <p>{this.state.cityname}</p>
            </a>
        );
    }
}

export default Locationhref;
